<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>탈퇴 회원 관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          회원관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/mem/withdrawal">탈퇴 회원 관리</a>
        </li>
      </ol>
    </div>
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="탈퇴일" :data="data" @search="search" @reset="reset" />
          <!-- 항목 검색 -->
          <sch-text label="탈퇴사유" :data="data" @search="search" @reset="reset" :type="'select_no'" style="width:100%"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->


    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">목록</span>
        <div class="card-tool float-right" >
          <b-btn class="btn btn-xs btn-outline-danger mr-2" variant="danger-primary">오늘 탈퇴 회원수 : {{today}} </b-btn>
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary">누적 탈퇴 회원수 : {{total}}  </b-btn>
        </div>
        <ShowCounter label="Show" class="ml-1" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td style="text-align:center">No</td>
              <td style="text-align:center">회원유형</td>
              <td style="text-align:center" @click="localSort.sort('withdrawReason')">탈퇴사유<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('loginId')">ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('withdrawDt')">탈퇴일시<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
            <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index"  > <!--  @click.prevent="edit(item.seq);" -->
              <td class="align-middle text-center" >{{item.rowNum}}</td>
               <td class="align-middle text-center" >
                  <span v-show="item.typeCd == '105002'">학교교사<span v-show="item.typeCd == '105003' || item.typeCd == '105005' || item.typeCd == '105006'">,</span> </span> 
                  <span v-show="item.typeCd == '105003'">학원강사<span v-show="item.typeCd == '105005' || item.typeCd == '105006'">,</span></span> 
                  <span v-show="item.typeCd == '105005'">학생<span v-show="item.typeCd == '105006'">,</span></span>  
                  <span v-show="item.typeCd == '105006'">학부모 </span>
               </td>
              <td class="align-middle text-center" >{{item.withdrawReason}}</td>
              <td class="align-middle text-center" >{{item.loginId}}</td>
              <td class="align-middle text-center" >{{item.withdrawDt}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->
  </ContentWrapper>
</template>
<script>
import Vue from 'vue'
import { reactive, ref, computed, onMounted, onUnmounted ,onBeforeMount} from '@vue/composition-api'
import {dataObject,userTypeCd,schoolDivCd,subjectCd1,subjectCd2,subjectCd3} from "@/utils/Constants";
import {getUserList,setSuspended,getUserWithdrawn} from "@/api/mem/MemberAPI";
import {getBoardCatList,setBoardCatList, deleteBoardCatList} from "@/api/notice/BoardCatApi";
import {getUserJoinYn} from "@/api/mem/extMemberAPI";
import {getSsoAdmList} from "@/api/sso/SsoAdmApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import Keyword from "../../components/Common/Keyword";
import Datepicker from 'vuejs-datepicker';
import swal from 'sweetalert2'
import Axios from 'axios';
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import draggable from 'vuedraggable'
// 목차/차시/파일
import vueMoment from 'vue-moment' 

Vue.use(vueMoment)


let defaultProps
export default {
  components: {SchText, ShowCounter, Pagenation,  Loading, draggable, Keyword,SchDateRange, Datepicker},

  setup(props, {root}){
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject);

    const today = ref();
    const total = ref();

    const loadData = async () => {
      let result = await getUserWithdrawn(data.params);
      data.list = result.data.userWithdrawnOrDeletedList;
      root.$_localSort.set(data.list); 
      data.count = result.count;

      total.value = result.data.totalCount;
      today.value = result.data.todayCount;
    }

    onMounted(loadData)

    return{
      dataObject,
      _dataObject,
      data,
      userTypeCd,
      today,
      total,
      ...methods(),
      dataAction: new TableActionClass(data),
      localSort:root.$_localSort
    }
  },
}

function methods() {
  var context = {};
  context["getUserWithdrawn"] = getUserWithdrawn;

  // 목록
  async function search() {
    this.data.params.schType = 'withdrawReason';
    let _params = this.data.params;

    let result = await getUserWithdrawn(_params);
    this.data.list = result.data.userWithdrawnOrDeletedList;
    this.localSort.set(this.data.list); 
    this.data.count = result.count;

    this.total = result.data.totalCount;
    this.today = result.data.todayCount;
    
  }
  // 초기화
  async function reset(){
    this.data.params.mode="list";
  }

  return {
    search,
    reset,
  }
}

</script>
